import {t} from '../../../common/getTranslations';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {Control} from '../../molecules/Control/Control';
import {ViewerSettingContentMarginProps} from './ViewerSettingContentMarginProps.interface';
import {ViewerSettingScrollableItem} from './ViewerSettingScrollableItem';

export function ViewerSettingContentMargin({
  isMobile,
  currentContentMargin,
  onClickContentMarginMinus = () => {},
  onClickContentMarginPlus = () => {},
  isContentMarginMinusDisabled = false,
  isContentMarginPlusDisabled = false,
}: ViewerSettingContentMarginProps) {
  return (
    <ViewerSettingScrollableItem
      isMobile={isMobile}
      title={t('viewer_setting_margin')}
      className={isMobile ? 'mt-6pxr' : 'mt-10pxr'}
    >
      <Control
        count={currentContentMargin}
        onClickMinus={e =>
          LOG_CLICK_EVENT('여백_클릭', e, onClickContentMarginMinus)
        }
        onClickPlus={e =>
          LOG_CLICK_EVENT('여백_클릭', e, onClickContentMarginPlus)
        }
        isMinusDisabled={isContentMarginMinusDisabled}
        isPlusDisabled={isContentMarginPlusDisabled}
        isLoggingZoom
      />
    </ViewerSettingScrollableItem>
  );
}
